import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.869 19.283a.7.7 0 0 0 .99 0l.424-.424a.7.7 0 0 0 0-.99L13.414 12l5.87-5.869a.7.7 0 0 0 0-.99l-.425-.424a.7.7 0 0 0-.99 0L12 10.586l-5.869-5.87a.7.7 0 0 0-.99 0l-.424.425a.7.7 0 0 0 0 .99L10.586 12l-5.87 5.87a.7.7 0 0 0 0 .989l.425.424a.7.7 0 0 0 .99 0L12 13.414l5.869 5.87Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol